var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstrologyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69292 17.3953C7.69292 16.8499 7.24925 16.4062 6.70391 16.4062C6.15852 16.4062 5.71484 16.8499 5.71484 17.3953C5.71484 17.9406 6.15852 18.3843 6.70391 18.3843C7.24925 18.3843 7.69292 17.9406 7.69292 17.3953ZM17.4944 7.56689C18.025 7.56689 18.4566 7.13527 18.4566 6.60473C18.4566 6.0742 18.025 5.64258 17.4944 5.64258C16.964 5.64258 16.5323 6.0742 16.5323 6.60473C16.5323 7.13527 16.9639 7.56689 17.4944 7.56689Z",
    fill: "url(#paint0_linear_6114_7765)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62713 4.49253C4.16009 4.49253 4.59214 4.06048 4.59214 3.52752C4.59214 2.99455 4.16009 2.5625 3.62713 2.5625C3.09416 2.5625 2.66211 2.99455 2.66211 3.52752C2.66211 4.06048 3.09416 4.49253 3.62713 4.49253Z",
    fill: "url(#paint1_linear_6114_7765)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8462 10.9048C12.7754 10.9045 12.71 10.8667 12.6743 10.8056L12.2728 10.1174C12.1957 9.98511 12.0045 9.98511 11.9273 10.1174L11.5258 10.8056C11.4902 10.8667 11.4248 10.9045 11.354 10.9048L10.5557 10.9084C10.4025 10.9091 10.3069 11.0746 10.3829 11.2076L10.7789 11.9009C10.814 11.9624 10.814 12.0378 10.7789 12.0993L10.3829 12.7926C10.3069 12.9256 10.4025 13.0911 10.5557 13.0918L11.354 13.0954C11.4248 13.0957 11.4902 13.1334 11.5258 13.1946L11.9273 13.8828C12.0045 14.0151 12.1957 14.0151 12.2728 13.8828L12.6743 13.1946C12.71 13.1334 12.7754 13.0957 12.8462 13.0954L13.6445 13.0918C13.7976 13.0911 13.8932 12.9256 13.8172 12.7926L13.4212 12.0993C13.3861 12.0378 13.3861 11.9624 13.4212 11.9009L13.8172 11.2076C13.8932 11.0746 13.7976 10.9091 13.6445 10.9084L12.8462 10.9048Z",
    fill: "url(#paint2_linear_6114_7765)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.201 20.4727C18.201 19.1651 19.2647 18.1014 20.5723 18.1014C21.1492 18.1014 21.6785 18.3087 22.09 18.6525C23.397 16.6987 24.0996 14.4036 24.0996 12C24.0996 8.79469 22.8514 5.78123 20.5849 3.51469C18.3184 1.24823 15.3049 0 12.0996 0C9.69605 0 7.40086 0.702703 5.44716 2.00958C5.79089 2.42114 5.99822 2.95041 5.99822 3.52734C5.99822 4.83488 4.93448 5.89861 3.62695 5.89861C3.05002 5.89861 2.52075 5.69128 2.10919 5.34755C0.802266 7.30125 0.0996094 9.59644 0.0996094 12C0.0996094 15.2053 1.34784 18.2188 3.6143 20.4853C5.88084 22.7518 8.8943 24 12.0996 24C14.5032 24 16.7984 23.2973 18.7521 21.9904C18.4083 21.5789 18.201 21.0496 18.201 20.4727ZM12.0996 20.333C10.6973 20.333 9.33806 19.9861 8.12226 19.3242C7.725 19.617 7.23464 19.7905 6.70434 19.7905C5.38355 19.7905 4.30903 18.716 4.30903 17.3953C4.30903 16.865 4.48252 16.3746 4.77534 15.9773C4.11352 14.7616 3.76664 13.4024 3.76664 12C3.76664 7.40517 7.50478 3.66703 12.0996 3.66703C13.512 3.66703 14.8807 4.01878 16.1032 4.69003C16.4942 4.40503 16.9751 4.23633 17.4948 4.23633C18.8008 4.23633 19.8632 5.2988 19.8632 6.60473C19.8632 7.12453 19.6945 7.60542 19.4095 7.99641C20.0807 9.21881 20.4325 10.5875 20.4325 12C20.4326 16.5948 16.6944 20.333 12.0996 20.333Z",
    fill: "url(#paint3_linear_6114_7765)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5724 21.4378C21.1054 21.4378 21.5375 21.0058 21.5375 20.4728C21.5375 19.9399 21.1054 19.5078 20.5724 19.5078C20.0395 19.5078 19.6074 19.9399 19.6074 20.4728C19.6074 21.0058 20.0395 21.4378 20.5724 21.4378Z",
    fill: "url(#paint4_linear_6114_7765)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4948 8.9731C16.1889 8.9731 15.1265 7.91063 15.1265 6.6047C15.1265 6.45567 15.1405 6.30992 15.1671 6.16855C15.204 5.97284 15.125 5.76462 14.9434 5.68271C14.0557 5.28218 13.0909 5.07324 12.0996 5.07324C8.28019 5.07324 5.17285 8.18059 5.17285 12C5.17285 12.9814 5.37771 13.9368 5.77043 14.8171C5.85192 14.9998 6.0612 15.0795 6.25771 15.0421C6.40467 15.0141 6.55419 14.9999 6.7043 15C8.02505 15 9.09957 16.0745 9.09957 17.3952C9.0996 17.5453 9.08546 17.6948 9.05746 17.8418C9.02002 18.0383 9.09974 18.2476 9.28245 18.3291C10.1628 18.7218 11.1182 18.9267 12.0996 18.9267C15.9189 18.9267 19.0263 15.8193 19.0263 12C19.0263 11.0087 18.8174 10.0439 18.4169 9.15628C18.335 8.97469 18.1267 8.89567 17.9309 8.93249C17.7873 8.95948 17.6414 8.97312 17.4948 8.9731ZM16.0632 13.8902C16.2151 14.1562 16.024 14.4873 15.7177 14.4886L13.7697 14.4973C13.628 14.498 13.4973 14.5734 13.426 14.6958L12.4451 16.3773C12.2907 16.6419 11.9084 16.6419 11.7541 16.3773L10.7731 14.6958C10.7018 14.5735 10.571 14.498 10.4294 14.4974L8.48143 14.4887C8.17513 14.4873 7.98396 14.1562 8.13589 13.8903L9.10231 12.1984C9.17253 12.0754 9.17253 11.9245 9.10231 11.8016L8.13593 10.1097C7.984 9.84372 8.17517 9.51267 8.48147 9.5113L10.4295 9.50259C10.5711 9.50196 10.7018 9.42648 10.7732 9.30414L11.7541 7.62262C11.9084 7.35802 12.2907 7.35801 12.4451 7.62261L13.426 9.3041C13.4974 9.42644 13.6281 9.50191 13.7697 9.50254L15.7177 9.51126C16.024 9.51262 16.2152 9.84367 16.0633 10.1096L15.0968 11.8016C15.0266 11.9245 15.0266 12.0754 15.0968 12.1984L16.0632 13.8902Z",
    fill: "url(#paint5_linear_6114_7765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6114_7765",
    x1: 5.71484,
    y1: 12.0134,
    x2: 18.4566,
    y2: 12.0134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6114_7765",
    x1: 2.66211,
    y1: 3.52752,
    x2: 4.59214,
    y2: 3.52752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6114_7765",
    x1: 10.2129,
    y1: 12.0001,
    x2: 13.9873,
    y2: 12.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6114_7765",
    x1: 0.0996094,
    y1: 12,
    x2: 24.0996,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6114_7765",
    x1: 19.6074,
    y1: 20.4728,
    x2: 21.5375,
    y2: 20.4728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6114_7765",
    x1: 5.17285,
    y1: 12,
    x2: 19.0263,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstrologyActive);
export default __webpack_public_path__ + "static/media/astrologyActive.a6ddadc2eee19263a92d3d3f1b0842ed.svg";
export { ForwardRef as ReactComponent };